module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.scss
// module id = ./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.scss
// module chunks = 0